import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@onefootprint/ui';
import type React from 'react';
export type FieldProps = {
  label: string;
  children: React.ReactNode;
  tooltip?: string;
};
const Field = t0 => {
  const $ = _c(12);
  const {
    label,
    children,
    tooltip
  } = t0;
  const t1 = !tooltip;
  let t2;
  if ($[0] !== label) {
    t2 = <div className="text-label-2 text-tertiary mb-2 fp-text">{label}</div>;
    $[0] = label;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2 || $[4] !== tooltip) {
    t3 = <Tooltip disabled={t1} content={tooltip}>{t2}</Tooltip>;
    $[2] = t1;
    $[3] = t2;
    $[4] = tooltip;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== children) {
    t4 = <div className="text-body-2 text-primary fp-text max-md:wrap-anywhere">{children}</div>;
    $[6] = children;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== label || $[9] !== t3 || $[10] !== t4) {
    t5 = <div role="row" aria-label={label}>{t3}{t4}</div>;
    $[8] = label;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default Field;